// Rotating hero headlines — same H1, different audience each time it cycles.
// Each entry is { lead, accent }: `lead` renders in the normal weight/color,
// `accent` renders in the italic accent color, matching the original static
// headline's two-clause treatment. Order is deliberate: discoverability
// framing first (a distinct objection from "does it convert" — most people
// don't realize a good-looking site can still be invisible to search), then
// general framing, then the specific pain points that map to how people
// actually find this site (DM-based sellers, budget-conscious first-timers,
// people who've been burned before, people comparing themselves to
// competitors, people with a slow/broken site already).
export const heroHeadlines = [
  {
    lead: 'A great-looking website nobody finds',
    accent: 'is just an expensive business card.',
  },
  {
    lead: 'Turn your website into',
    accent: 'your best salesperson.',
  },
  {
    lead: 'Your website is either selling,',
    accent: 'or costing you.',
  },
  {
    lead: 'Still taking orders through TikTok, IG, or WhatsApp DMs?',
    accent: 'A website sells for you, even while you sleep.',
  },
  {
    lead: 'Getting more sales online can seem impossible,',
    accent: "but it doesn't have to be.",
  },
  {
    lead: 'Think a real website is out of your budget?',
    accent: 'Ours start at $75.',
  },
  {
    lead: 'Tired of designers who disappear after the deposit?',
    accent: "We stay until it's actually done.",
  },
  {
    lead: 'Your competitors already have a website working for them.',
    accent: 'Do you?',
  },
  {
    lead: "Losing customers to a site that's slow, broken, or missing on mobile?",
    accent: 'Fix it once. Keep the sales.',
  },
]
